import classNames from '@utils/classnames';
import { ErrorBoundary } from 'react-error-boundary';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Toaster, resolveValue } from 'react-hot-toast';
import { BrowserRouter } from 'react-router-dom';
import { captureException } from '@sentry/react';

import { AppRoutes } from './AppRoutes';
import { ErrorFallback } from './components/ErrorFallback';
import { TranslationProvider } from './contexts/translation-context';

// @ts-ignore
const APP_VERSION = import.meta.env.VITE_APP_VERSION;

export const App = () => {
  return (
    <TranslationProvider>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onError={(err) => {
          captureException(err);
        }}
        onReset={() => {
          // eslint-disable-next-line no-restricted-globals
          window.location.reload();
        }}
      >
        <HelmetProvider>
          <Helmet>
            <link href="/favicon.svg" rel="shortcut icon" type="image/x-icon"></link>
            <meta name="app:version" content={APP_VERSION ?? 'dev'} />
          </Helmet>

          <BrowserRouter>
            <AppRoutes />

            <Toaster position="bottom-right">
              {(t) => (
                <div
                  className={classNames('flex justify-center items-center flex-wrap px-4 py-2 rounded', {
                    'opacity-0': !t.visible,
                    'opacity-100': t.visible,
                    'bg-negative text-fg-inverse': t.type === 'error',
                    'bg-positive text-fg-inverse': t.type === 'success',
                    'bg-surface-sunken text-fg border border-border': t.type !== 'error' && t.type !== 'success',
                  })}
                >
                  {resolveValue(t.message, t)}
                </div>
              )}
            </Toaster>
          </BrowserRouter>
        </HelmetProvider>
      </ErrorBoundary>
    </TranslationProvider>
  );
};
